
<div>
  <label :for="relatedModelUpdate.idForProp('related_model_id')" class="a-select-label">
    Update Which Related Model?</label>
  <a-select :options="linkedModelOptions"
            :id="relatedModelUpdate.idForProp('related_model_id')"
            :key="relatedModelUpdate.related_model_id ? relatedModelUpdate.related_model_id: 'select-models'"
            compress
            @input="clearPropertyUpdates"
            v-model="relatedModelUpdate.related_model_id"></a-select>
  <template v-if="relatedModelUpdate.related_model_id"
            v-for="(propertyUpdate,  index) in relatedModelUpdate.propertyUpdatesArray">
    <panel-item>
      <configure-property-update
        :deleteable="index !== 0"
        :key="propertyUpdate.property_client_id"
        :property-update="propertyUpdate"
        :property-options="updateableProperties"
        v-on:remove="removePropertyUpdate(propertyUpdate)"
      >
        <template v-if="propertyUpdate.property_client_id">
          <component
            v-if="isPickList(propertyUpdate.property_client_id)"
            :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
            :id="`update_value_${propertyUpdate.property_client_id}`"
            :key="`update_value_${propertyUpdate.property_client_id}`"
            class="mb-0"
            :property-client-id="propertyUpdate.property_client_id"
            :object-model="selectedObjectModel"
            v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
            v-model="propertyUpdate.values_to_update_to_array"
          ></component>
          <component
            v-else="propertyUpdate.property_client_id"
            :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
            :id="`update_value_${propertyUpdate.property_client_id}`"
            :key="`update_value_${propertyUpdate.property_client_id}`"
            class="mb-0"
            :property-client-id="propertyUpdate.property_client_id"
            :object-model="selectedObjectModel"
            v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
            v-model="propertyUpdate.value_to_update_to"
          ></component>
        </template>
      </configure-property-update>
    </panel-item>
  </template>
  <panel-actions v-if="relatedModelUpdate.related_model_id">
    <button @click="addPropertyUpdate" type="button" class="btn grey-to-blue full-sz" >
      Add Property to Update
    </button>
  </panel-actions>
</div>
